import { render, staticRenderFns } from "./LabSelect.vue?vue&type=template&id=2fce5812&"
import script from "./LabSelect.vue?vue&type=script&lang=js&"
export * from "./LabSelect.vue?vue&type=script&lang=js&"
import style0 from "./LabSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports